import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import {STATUS_MESSAGE} from "./Typeahead";
import DropdownWrapper from "../../../components/DropdownWrapper";

export default class DropdownMenu extends React.Component {
    constructor(props) {
        super(props);
        this.onSort = this.onSort.bind(this);
        this.renderedItems = [];
    }

    onSort(e, key) {
        const {onSort, sort} = this.props;
        e.preventDefault();
        e.stopPropagation();
        let dir = "asc";
        if(key === sort.key) {
            if(sort.dir === "asc") {
                // change direction
                dir = "desc";
            }
            else if(sort.dir === "desc") {
                // remove sort
                dir = "";
                key = "";
            }
        }
        onSort && onSort({key, dir});
    }

    filteredOptions() {
        const {options, columns, searchText, keepSelectionInList, sort, isServer} = this.props;

        let newOptions = [...options];
        if(!keepSelectionInList) {
            // remove selected item(s) from list
            newOptions = newOptions.filter(item => !this.isItemSelected(item));
        }

        if(isServer) {
            // Server options are not sorted or searched.
            return newOptions;
        }
        // first filter the options
        if(searchText.length) {
            // Search multiple terms separated by space.
            const terms = searchText.trim().toLowerCase().split(" ");
            newOptions = newOptions.filter((item) => {
                let found = false;
                if(searchText.length) {
                    let foundAll = 0;
                    // create a synthetic string for all the filterable columns.
                    let rowText = "";
                    columns.forEach((column) => {
                        if(column.includeInFilter === false) {
                            return;
                        }
                        const value = item[column.key] || "";
                        // build the text we want to search against
                        rowText += value.toString().toLowerCase();

                    });
                    terms.forEach((s) => {
                        if (rowText.indexOf(s) !== -1) {
                            // a term was found
                            foundAll++;
                        }
                    });
                    if(terms.length <= foundAll) {
                        // found all the terms
                        found = true;
                    }
                }
                else {
                    found = true;
                }
                return found;
            });
        }

        // now sort the options
        const sortDir = sort.dir === "asc" ? 1 : -1;
        if (sort.key && sort.dir) {
            const beginswith = [];
            const caseSensitive = [];
            const caseInsensitive = [];
            let item = undefined;
            while ((item = newOptions.shift())) {
                if(!item[sort.key]) {
                    // key does not exist
                    continue;
                }
                const label = item[sort.key].toString();
                if (label.toLowerCase().indexOf(searchText.toLowerCase()) === 0) {
                    beginswith.push(item);
                } else if (label.indexOf(searchText) >= 0) {
                    caseSensitive.push(item);
                } else {
                    caseInsensitive.push(item);
                }
            }
            newOptions = beginswith.concat(caseSensitive, caseInsensitive);

            newOptions.sort((obj1, obj2) => {
                if (obj1[sort.key] > obj2[sort.key]) {
                    return sortDir;
                }
                if (obj1[sort.key] < obj2[sort.key]) {
                    return -sortDir;
                }
                return 0;
            });
        }
        return newOptions;
    }

    buildHeaderColumns() {
        const {columns, sort} = this.props;
        if(columns.length <= 1) {
            return null;
        }

        return (
            <tr>
                {columns.map((column, index) => {
                    const classnames = classNames({
                        "sortable": column.isSortable !== false,
                        [sort.dir]: sort.key === column.key && column.isSortable !== false,
                    });
                    return (
                        <th
                            key={index}
                            className={classnames}
                            onClick={(e) => column.isSortable !== false ? this.onSort(e, column.key) : null}
                        >
                            {column.label} <span />
                        </th>
                    );
                })}
            </tr>
        );
    }

    buildItemColumns(item, index) {
        const {onSelect, columns, searchText, labelKey} = this.props;
        const selected = this.isItemSelected(item);
        return (
            <tr className={selected ? "active" : ""} key={index} onClick={() => onSelect(item, index)}>
                {columns.map((column, index) => {
                    let label = item[column.key] || item[labelKey];
                    if(label.length && column.includeInFilter && searchText.length) {
                        searchText.trim().split(" ").forEach((s) => {
                            const query = s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
                            label = label.replace(new RegExp(`(${query})`, "ig"), ($1, match) => `<strong>${match}</strong>`);
                        });
                    }
                    return (
                    <td key={index} dangerouslySetInnerHTML={{__html: label}}/>
                );})}
            </tr>
        );
    }

    getActiveIndex(items) {
        const {selected, multiValued, keepSelectionInList} = this.props;
        if(selected && !multiValued && keepSelectionInList) {
            for(const index in items) {
                const item = items[index];
                if(this.isItemSelected(item)) {
                    return parseInt(index, 10);
                }
            }
        }
        return 0;
    }

    isItemSelected(item) {
        const {selected, multiValued, valueKey} = this.props;
        let active = false;
        if(selected !== null) {
            if(multiValued) {
                active = selected.find((v) => v[valueKey] == item[valueKey]);
            }
            else {
                if (item[valueKey] == selected[valueKey]) {
                    active = true;
                }
            }
        }
        return active;
    }

    render() {
        const {
            show,
            statusMessage,
            isLoading
        } = this.props;

        if(!show) {
            return (<div ref={this.dropdownRef} />);
        }
        let items = this.filteredOptions();

        let status = statusMessage;
        if(items.length > 100 && !statusMessage) {
            status = STATUS_MESSAGE.PARTIAL;
            items = items.slice(0, 100);
        }

        this.renderedItems = items;

        return (
            this.props.show &&
            <DropdownWrapper
                targetRef={this.props.targetRef}
                dropdownLength={this.props.dropdownLength}
                itemSelector={"tbody tr"}
                ignoreClickSelector={".sortable"}
                initialActiveIndex={this.getActiveIndex(this.renderedItems)}
                activeItemClass={"hover"}
                ignoreSpaceKey={true}
                onHide={this.props.onHide}
                onEnterKey={(e, index) => {
                    this.props.onSelect(this.renderedItems[index], index);
                    this.props.onHide();
                }}
            >
                <div ref={this.dropdownRef} className={`typeahead-dropdown ${isLoading ? "" : "with-scroller"}`}>
                    <table className="table scroller">
                        <thead>{this.buildHeaderColumns()}</thead>
                        <tbody>
                        {items.map((item, index) => this.buildItemColumns(item, index))}
                        </tbody>
                    </table>
                    {items.length === 0 && <div className="list-group-item empty"><strong>{STATUS_MESSAGE.EMPTY}</strong></div>}
                    {status && <div className="list-group-item status-message"><strong>{status}</strong></div>}
                    {isLoading && <div className="list-group-item loading"><strong>{STATUS_MESSAGE.LOADING}</strong></div>}
                </div>
            </DropdownWrapper>
        );
    }
}

DropdownMenu.defaultProps = {
    dropdownLength: 8,
    searchText: "",
};

DropdownMenu.propTypes = {
    targetRef: PropTypes.object.isRequired,
    show: PropTypes.bool.isRequired,
    selected: PropTypes.any,
    searchText: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
    onSort: PropTypes.func,
    sort: PropTypes.shape({
        key: PropTypes.string,
        dir: PropTypes.string
    }).isRequired,
    options: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    columns: PropTypes.arrayOf(PropTypes.shape({
        includeInFilter: PropTypes.bool,
        isSortable: PropTypes.bool,
        key: PropTypes.string.isRequired,
        label: PropTypes.string,
    })).isRequired,
    valueKey: PropTypes.string.isRequired,
    labelKey: PropTypes.string.isRequired,
    multiValued: PropTypes.bool,
    statusMessage: PropTypes.string,
    dropdownLength: PropTypes.number,
    keepSelectionInList: PropTypes.bool,
    isServer: PropTypes.bool,
    isLoading: PropTypes.bool,
};




// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/BaseControls/Typeahead/DropdownMenu.js